module.exports = __webpack_public_path__ + "static/media/Register.e93998ca.jpg";